import React from 'react';
var PageWrapper = function (_a) {
    var children = _a.children;
    return <div className="c-page-wrapper">{children}</div>;
};
export default PageWrapper;
